// extracted by mini-css-extract-plugin
module.exports = {"documentContainer":"onfido-sdk-ui-Capture-documentContainer","faceContainer":"onfido-sdk-ui-Capture-faceContainer","uploadFallback":"onfido-sdk-ui-Capture-uploadFallback"};